import { RESOURCE_ERROR_KINDS } from './fetchJsonResource';

const MAX_RETRY_ATTEMPTS = 3;
const BASE_DELAY_MS = 700;
const MAX_DELAY_MS = 8000;
const JITTER_RATIO = 0.5;

function isRetryableErrorKind(errorKind) {
    return errorKind === RESOURCE_ERROR_KINDS.RATE_LIMITED;
}

function shouldRetry(error, attemptsMade) {
    return attemptsMade < MAX_RETRY_ATTEMPTS && isRetryableErrorKind(error && error.kind);
}

function clampDelay(delayMs) {
    return Math.min(Math.max(delayMs, 0), MAX_DELAY_MS);
}

function resolveBaseDelayMs(error, attemptsMade) {
    const serverDelayMs = error && error.retryAfterMs;
    if (Number.isFinite(serverDelayMs) && serverDelayMs > 0) {
        return serverDelayMs;
    }

    return BASE_DELAY_MS * (2 ** attemptsMade);
}

function resolveRetryDelayMs(error, attemptsMade, random = Math.random) {
    const baseDelayMs = resolveBaseDelayMs(error, attemptsMade);

    return clampDelay(Math.round(baseDelayMs * (1 + (random() * JITTER_RATIO))));
}

export {
    BASE_DELAY_MS,
    MAX_DELAY_MS,
    MAX_RETRY_ATTEMPTS,
    isRetryableErrorKind,
    resolveRetryDelayMs,
    shouldRetry,
};
